export default __webpack_public_path__ + "static/media/loading.7f11a3a7.gif";